import { styled } from '@mui/material';

export const ImageViewerWrapper = styled('div')<{ $animateOnMount?: boolean }>(({ $animateOnMount = true }) => ({
  animation: $animateOnMount ? 'fadeInUp 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards' : undefined,
  background: '#F3F8FD',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  minHeight: '100%',
  minWidth: 0,
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  '@keyframes fadeInUp': {
    '0%': {
      opacity: 0,
      transform: 'translateY(30px)',
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}));

export const ImageViewerStateContainer = styled('div')({
  padding: '20px',
  textAlign: 'center',
});

export const ImageViewerScrollContainer = styled('div')<{
  $isPannable?: boolean;
  $isPanning?: boolean;
  $isResizing?: boolean;
}>(({ $isPannable, $isPanning, $isResizing }) => ({
  background: 'linear-gradient(180deg, #F3F8FD 0%, #EEF4F8 100%)',
  boxSizing: 'border-box',
  flex: '1 1 auto',
  minHeight: 0,
  overflowAnchor: 'none',
  overflow: $isResizing ? 'hidden' : 'auto',
  position: 'relative',
  scrollbarGutter: 'stable',
  userSelect: $isPanning ? 'none' : undefined,
  width: '100%',
  '&:hover': {
    cursor: $isPannable ? 'grab' : undefined,
  },
  '&[data-panning="true"], &[data-panning="true"]:hover': {
    cursor: 'grabbing',
  },
  '&[data-panning="true"] *': {
    cursor: 'grabbing !important',
  },
}));

export const ImageViewerCanvas = styled('div')<{
  $isHidden?: boolean;
  $isResizing?: boolean;
}>(({ $isHidden, $isResizing }) => {
  const contentOpacity = (() => {
    if ($isHidden) {
      return 0;
    }

    if ($isResizing) {
      return 0.56;
    }

    return 1;
  })();

  return {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    filter: $isResizing ? 'blur(1.5px)' : undefined,
    justifyContent: 'center',
    minHeight: '100%',
    minWidth: '100%',
    opacity: contentOpacity,
    padding: '16px',
    pointerEvents: $isHidden || $isResizing ? 'none' : undefined,
    transition: 'filter 140ms ease-out, opacity 140ms ease-out',
  };
});

export const ImageViewerContainer = styled('div')({
  backgroundColor: '#fff',
  border: '1px solid #D8E3EE',
  borderRadius: 10,
  boxShadow: '0 10px 24px rgba(15, 23, 42, 0.08)',
  boxSizing: 'border-box',
  overflow: 'hidden',
});

export const ImageViewerImage = styled('img')({
  display: 'block',
  height: '100%',
  objectFit: 'contain',
  width: '100%',
});
